import * as types from './mutation-types'

export default {

  [types.ADD_GENDERS] (state, data) {
    state.genders = data.genders
  }

}
